module.exports = __webpack_public_path__ + "4da1f6c565f0faa7afe8c11325a11df9.pdf";